import { render, staticRenderFns } from "./AllComments.vue?vue&type=template&id=43d3cb84&"
import script from "./AllComments.vue?vue&type=script&lang=js&"
export * from "./AllComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports